<template>
  <div>
    <table width="100%">
      <thead>
        <tr>
          <th>
            <my-header h1="Fee Deposite Record" v-bind:h2="h2" v-bind:h3="h3"></my-header>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <table border="1" width="100%" style="border-collapse: collapse; font-size: 12px">
              <tr>
                <th class="bg" align="left" width="20">Session:</th>
                <td align="left" width="20">{{sess}}</td>
                <th class="bg" align="left" width="15">Degree:</th>
                <td align="left" width="15">{{deg}}</td>
                <th class="bg" align="left" width="20">Program:</th>
                <td align="left" width="20">{{pro}}</td>
              </tr>
              <tr>
                <th class="bg" align="left" width="15">Category:</th>
                <td align="left" width="15">{{cat}}</td>
                <th class="bg" align="left" width="15">Date From:</th>
                <td align="left" width="15">{{dateFrom}}</td>
                <th class="bg" align="left" width="15">Date To:</th>
                <td align="left" width="15">{{dateTo}}</td>
              </tr>
            </table>

            <table border="1" width="100%" style="border-collapse:collapse; font-size: 12px; margin-top:10px">
              <thead>
                <tr>
                  <th class="bg">Sr. No.</th>
                  <th class="bg">Form No.</th>
                  <th class="bg">Challan No.</th>
                  <th class="bg">Name</th>
                  <th class="bg">Father Name</th>
                  <th class="bg">Program Name</th>
                  <th class="bg">CNIC</th>
                  <th class="bg">Mobile No.</th>

                  <th class="bg">Gen. Date</th>
                  <th class="bg">Due Date</th>
                  <th class="bg">Deposit Date</th>
                  <th class="bg">Total Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, ind) in data">
                  <td align="center">{{ind+1 }}</td>
                  <td>{{item.FormNo}}</td>
                  <td>{{item.ChallanNo}}</td>
                  <td align="left">{{item.Name}}</td>
                  <td align="left">{{item.FathersName}}</td>
                  <td align="left">{{item.ProgramName}}</td>
                  <td align="right">{{item.CNIC}}</td>
                  <td align="right">{{item.MobileNo}}</td>

                  <td align="right">{{item.DateGeneration}}</td>
                  <td align="right">{{item.DueDate}}</td>
                  <td align="right">{{item.DepositDate}}</td>
                  <td align="right">{{item.TotalAmount.toLocaleString()}}</td>
                </tr>
                <tr>
                  <th class="bg" colspan="11">Total Amount</th>
                  <th class="bg" align="right">{{grandTotall}}</th>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>


<script>
  const axios = require('axios').default;
  export default ({
    data() {
      return {
        data: [],
        sess: '',
        pro: '',
        dep: '',
        deg: '',
        cat: '',
        dateFrom:'',
        dateTo: '',
        grandTotall: '',
        h2:'',
        h3:'',
      }
    },
    mounted: function () {
      this.pagePrint();
    },
    methods: {
      pagePrint() {
        var vm = this;
        axios.post('/api/FeeApi/loadFeeDepositList')
          .then(function (res) {
            vm.data = res.data.dataSet;
            vm.sess = res.data.sess;
            vm.pro = res.data.pro;
            vm.grandTotall = res.data.totalFee.toLocaleString();
            vm.deg = res.data.deg;
            vm.cat = res.data.cat;
            vm.dateFrom = res.data.DateFrom;
            vm.dateTo = res.data.DateTo;
            vm.h2 = "Department: " +  res.data.dataSet[0].DepartmentName;
            vm.h3 = "Faculty: " + res.data.dataSet[0].Faculty
          })
      }
    }
  })
</script>
<style>
  .bg {
    background-color: lightgrey;
  }
</style>



// WEBPACK FOOTER //
// src/components/fee/feeDepositListPrint.vue